import defaultTree from "../../default_tree";
import batchDestroyNodes from "./batchDestroyNodes";

export default async (tree = window.tree) => {
  const allNodes = tree.findAll(({ key, data }) => key !== "tephra" && !data.tephra);
  const fileInTree = keyword => {
    const finder = n => {
      if (n.key == keyword) return true;
      else if (n.children) return n.children.some(finder);
    };
    return defaultTree.tree.some(finder);
  };
  const expendableNodes = allNodes.filter(node => !fileInTree(node.key));
  const nodes_to_delete = [];
  expendableNodes.forEach(element => {
    nodes_to_delete.push({
      id: element.key,
      file_type: element.data.file_type
    });
  });

  return nodes_to_delete.length > 0 ? await batchDestroyNodes(nodes_to_delete) : Promise.resolve(true);
};
